'use client';

import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { useParams, useHistory } from 'react-router-dom';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import {
  bulkDeleteMedia,
  removeMedia,
  addMediaGroupToBeEdited,
} from 'state/actions/media';
import { getAccess } from 'utils';
import { imgUrl } from 'utils/url';
import moment from 'moment';
import { saveAs } from 'file-saver';
import {
  EditIcon,
  ForwardIcon,
  ImportIcon,
  MaximizeIcon,
  TrashIcon,
  CalendarTickIcon,
} from 'assets/icon';
import ModalDelete from 'components/ModalDelete';

const PopUpMediaTimeline = ({ media, type = 'media' }) => {
  const { siteId, siteName } = useParams();
  const [mediaPreviewModal, setMediaPreviewModal] = useState({
    isOpen: false,
  });
  const history = useHistory();
  const dispatch = useDispatch();
  const { userData, role, loading } = useSelector(
    (state) => ({
      userData: state.auth.userData,
      role: state.auth.userData.role,
      loading: state.media.loading,
    }),
    shallowEqual
  );
  const [access, setAccess] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deletedId, setDeletedId] = useState('');
  const [deleteGroupModal, setDeleteGroupModal] = useState(false);
  const [deletedMediaGroup, setDeletedMediaGroup] = useState(null);

  useEffect(() => {
    if (userData?.roleAccess) {
      setAccess(getAccess(userData, type, siteId));
    }
  }, [userData, type, siteId]);

  // edit
  const handleEdit = (id) => {
    dispatch(
      addMediaGroupToBeEdited(null, () => {
        history.push(`/${siteId}/information/${siteName}/media/${id}`);
      })
    );
  };

  const handleEditGroup = () => {
    dispatch(
      addMediaGroupToBeEdited(media, () => {
        history.push(`/${siteId}/information/${siteName}/media/${media._id}`);
      })
    );
  };

  // preview
  const getCategoryName = () => {
    if (media?.grouped?.length > 0) {
      const groupedCategoryName = media.grouped
        .map((e) => e.categoryName)
        .join(', ');
      return groupedCategoryName;
    } else {
      return media.categoryName;
    }
  };

  const onPreviewModalClickHandler = () => {
    setMediaPreviewModal((prevState) => ({
      ...prevState,
      isOpen: true,
      media,
    }));
  };

  const hidePreviewModal = () => {
    setMediaPreviewModal((prevState) => ({
      ...prevState,
      isOpen: !prevState.isOpen,
    }));
  };

  // download
  const downloadImage = (url, name) => {
    const fileType = type.split('/');
    saveAs(url, `${name}.${fileType[1]}`);
  };

  // delete
  const onRemoveButtonClickHandler = () => {
    dispatch(
      removeMedia({ id: deletedId, siteId }, () => {
        setDeleteModal(false);
        setDeletedId('');
      })
    );
  };
  const handleDelete = (mediaId) => {
    setDeleteModal(true);
    setDeletedId(mediaId);
  };

  const handleDeleteGroup = () => {
    setDeleteGroupModal(true);
    setDeletedMediaGroup(media);
  };

  const onDeleteMediaGroupHandler = () => {
    dispatch(
      bulkDeleteMedia(
        {
          siteId,
          data: deletedMediaGroup.grouped,
        },
        () => {
          setDeleteGroupModal(false);
          setDeletedMediaGroup(null);
        }
      )
    );
  };

  const getMedia = () => {
    // const findMedia = mediaList.find((cat) => cat._id === mediaId);
    // return mediaId ? findMedia?.name : '';
    return '';
  };

  const canEdit = role === 'superadmin';
  return (
    <>
      <div className="media-popup">
        {canEdit && (
          <button
            type="button"
            className="media-popup-item"
            onClick={() => {
              if (media?.grouped?.length > 0) {
                handleEditGroup(media);
              } else {
                handleEdit(media._id);
              }
            }}
          >
            <EditIcon style={{ width: 12, height: 12 }} />
          </button>
        )}

        <button
          type="button"
          className="media-popup-item"
          onClick={onPreviewModalClickHandler}
        >
          <MaximizeIcon style={{ width: 12, height: 12 }} />
        </button>

        <button
          type="button"
          className="media-popup-item"
          onClick={() =>
            downloadImage(
              `${imgUrl}/media/${media.logo}`,
              media.name.split(' ').join('-'),
              media.fileType
            )
          }
        >
          <ImportIcon style={{ width: 12, height: 12 }} />
        </button>

        {canEdit && (
          <button
            type="button"
            className="media-popup-item"
            onClick={() => {
              if (media?.grouped?.length > 0) {
                handleDeleteGroup(media);
              } else {
                handleDelete(media._id);
              }
            }}
          >
            <TrashIcon style={{ width: 12, height: 12 }} />
          </button>
        )}
      </div>
      {mediaPreviewModal.isOpen && (
        <Modal
          title={null}
          visible={mediaPreviewModal.isOpen}
          footer={null}
          onCancel={hidePreviewModal}
          className="custom-modal"
        >
          {mediaPreviewModal.media.logo &&
          mediaPreviewModal.media.fileType.split('/')[0] === 'image' ? (
            <img
              src={`${imgUrl}/media/${mediaPreviewModal.media.logo}`}
              alt="post"
            />
          ) : mediaPreviewModal.media.logo &&
            mediaPreviewModal.media.fileType.split('/')[0] === 'video' ? (
            <video id="my-video" className="video-js" data-setup="{}" controls>
              <source src={`${imgUrl}/media/${mediaPreviewModal.media.logo}`} />
            </video>
          ) : null}

          <div className="custom-modal-content">
            <h1 className="custom-modal-title">
              {mediaPreviewModal.media.name
                ? mediaPreviewModal.media.name
                : 'No Title'}
            </h1>
            <div className="custom-modal-details">
              <ul>
                <li>
                  <ForwardIcon /> {getCategoryName(mediaPreviewModal.media)}
                </li>

                <li>
                  <CalendarTickIcon />

                  {mediaPreviewModal.media.type === 'date'
                    ? `${moment(mediaPreviewModal.media.start).format(
                        'MMM, D YYYY'
                      )} - ${moment(mediaPreviewModal.media.end).format(
                        'MMM, D YYYY'
                      )}`
                    : mediaPreviewModal.media.type === 'day'
                    ? `${mediaPreviewModal.media.days[0].day} - ${
                        mediaPreviewModal.media.days[
                          mediaPreviewModal.media.days.length - 1
                        ].day
                      }`
                    : mediaPreviewModal.media.start &&
                      mediaPreviewModal.media.end
                    ? `${moment(mediaPreviewModal.media.start).format(
                        'MMM, D YYYY'
                      )} - ${moment(mediaPreviewModal.media.end).format(
                        'MMM, D YYYY'
                      )}`
                    : 'All Day'}
                </li>
              </ul>
            </div>
          </div>
        </Modal>
      )}
      <ModalDelete
        isVisible={deleteModal}
        onOk={onRemoveButtonClickHandler}
        onCancel={() => setDeleteModal(false)}
        title="Delete Media"
        subtitle={getMedia(deletedId)}
        loading={loading}
      />
      <ModalDelete
        isVisible={deleteGroupModal}
        onOk={onDeleteMediaGroupHandler}
        onCancel={() => setDeleteGroupModal(false)}
        title="Delete Media Group"
        loading={loading}
      />
    </>
  );
};

export default PopUpMediaTimeline;